<template>
    <v-card class="px-3 py-1 pt-md-2 pb-md-2" :style="{'border-radius': $vuetify.breakpoint.mdAndUp ? '22pt !important' : null}" outlined>
        <v-simple-table>
            <tbody :class="hover ? null : 'no_hover'">
                <tr v-for="student in students" :key="student.id">
                    <td :key="student.id" :style="{width: $vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xs ? '11.11%' : '15%'}" class="pa-0 pa-sm-1 pa-lg-2 responsive_td">
                        <slot name="student" :student="student">
                        </slot>
                    </td>
                    <td v-for="(lesson, l_index) in student.lessons" :key="'l_' + (l_index + student.id * (student.lessons.length))" :style="{width: $vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xs ? '11.11%' : '10.625%'}" class="pa-0 responsive_td">
                        <slot name="lesson" :lesson="lesson" :student="student">
                        </slot>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
    </v-card>
</template>

<script>

export default {
    name: 'LessonsTable',
    props: {
        dark: Boolean,
        hover: Boolean,
        students: Array[Object]
    },
    data: () => ({
    }),
    computed: {
    },
    methods: {
    }
}

</script>

<style lang="scss">
.no_hover {
   tr:hover {
      background-color: transparent !important;
   }
}
table {
    table-layout: fixed !important;
}
.responsive_td {
    height: 46px !important;
}
</style>
